import { useGetMissionDetail } from '../../hooks/useGetMissionDetail';

import MissionCompletedModal from './MissionCompletedModal';

interface ConnectedMissionCompletedModalProps {
  isOpen: boolean;
  isClosing: boolean;
  onClose: () => void;
  assignmentId: string;
}

function ConnectedMissionCompletedModal({
  isOpen,
  isClosing,
  onClose,
  assignmentId,
}: ConnectedMissionCompletedModalProps) {
  const { missionAssignment, isLoading } = useGetMissionDetail(assignmentId);

  return (
    <MissionCompletedModal
      isOpen={isOpen}
      isClosing={isClosing}
      onClose={onClose}
      missionAssignment={missionAssignment}
      isLoading={isLoading}
    />
  );
}

export default ConnectedMissionCompletedModal;
